import { Download } from "lucide-react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useDownloadPdf } from "@/shared/lib/utilities/download-pdf";
import { useOmniDataSheetFileDownloadMutation } from "../api/data-sheet-api";

/** DataSheetDownloadButton downloads the file of the data sheet. */
export function DataSheetDownloadButton({
  id,
  filename,
}: {
  id: string;
  filename: string;
}) {
  const [download, { isLoading, error, data, reset }] =
    useOmniDataSheetFileDownloadMutation();

  useDownloadPdf(data, reset);

  return (
    <>
      <Button
        variant="link"
        disabled={isLoading}
        onClick={() => download({ id })}
        title={t("Herunterladen")}
      >
        <Download />
        {filename}
      </Button>
      <RTKQueryErrorAlert error={error} />
    </>
  );
}
